import { Button } from '@/shared/ui/button';
import { Dialog, type DialogTone } from '@/shared/ui/dialog';
import type { PhxIconName } from '@/shared/ui/icon';

export interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Variant of the confirmation button — defaults to `danger`. */
  confirmVariant?: 'danger' | 'primary';
  onConfirm: () => void;
  onCancel: () => void;
}

const VARIANT_TONE: Record<NonNullable<ConfirmDialogProps['confirmVariant']>, DialogTone> = {
  danger: 'danger',
  primary: 'primary',
};

const VARIANT_ICON: Record<NonNullable<ConfirmDialogProps['confirmVariant']>, PhxIconName> = {
  danger: 'alert',
  primary: 'info',
};

/**
 * Modal confirmation dialog.  Wraps the Phoenix `Dialog` so consumers keep
 * the existing imperative `onConfirm`/`onCancel` API.
 */
export function ConfirmDialog({
  title,
  message,
  confirmLabel = 'Potvrdit',
  cancelLabel = 'Zrušit',
  confirmVariant = 'danger',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open
      onClose={onCancel}
      title={title}
      description={message}
      icon={VARIANT_ICON[confirmVariant]}
      tone={VARIANT_TONE[confirmVariant]}
      footer={
        <>
          <Button variant="outline" size="md" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={confirmVariant} size="md" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    />
  );
}
